import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';
import { Clock, Users, TrendingUp, MessageCircle, Star, Zap } from 'lucide-react';

const StatsBar = () => {
  const stats = [
    { icon: Clock, value: '75+ horas', label: 'ahorradas al mes' },
    { icon: Users, value: '95%', label: 'retención de pacientes' },
    { icon: TrendingUp, value: '3x', label: 'más adherencia' },
    { icon: MessageCircle, value: '24/7', label: 'disponibilidad' },
    { icon: Star, value: '4.9/5', label: 'satisfacción' },
    { icon: Zap, value: '< 5 min', label: 'configuración' },
  ];

  return (
    <section className="py-6 bg-[#F2F4F0] border-y border-[#2E5C41]/10" data-testid="stats-bar">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {[...stats, ...stats].map((stat, index) => (
          <div key={index} className="flex items-center gap-6 mx-8">
            <div className="flex items-center gap-3">
              <stat.icon className="w-5 h-5 text-[#2E5C41]" strokeWidth={1.5} />
              <span className="font-cabinet font-bold text-[#1A2E24]">{stat.value}</span>
              <span className="text-sm text-[#4B5E53]">{stat.label}</span>
            </div>
            <div className="w-1 h-1 bg-[#849B89] rounded-full" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default StatsBar;
